import { createReducer, on } from "@ngrx/store";
import { AuthState } from "./auth.models";
import * as authActions from './auth.actions';

export const initialAuthState: AuthState = {
  user: null,
  accessToken: null,
  refreshToken: null,
  loading: false,
  error: null,
  isAuthenticated: false,
};

export const authReducer = createReducer(
  initialAuthState,
  on(authActions.checkLogin, (state) => ({
    ...state,
    loading: true
  })),
  on(authActions.checkLoginSuccess, (state, {user, accessToken, refreshToken}) => ({
    ...state,
    loading: true,
    accessToken,
    refreshToken,
    user: user
  })),
  on(authActions.checkLoginFailure, (state) => ({
    ...state,
    loading: false
  })),
  on(authActions.loginSuccessful, (state) => ({
    ...state,
    loading: false,
    isAuthenticated: true
  })),
  on(authActions.loginUnsuccessful, (state) => ({
    ...state,
    loading: false,
    isAuthenticated: false
  })),
  on(authActions.submitLoginRequest, (state) => ({
    ...state,
    loading: true,
    isAuthenticated: false
  })),
  on(authActions.submitLoginRequestSuccess, (state, {user, accessToken, refreshToken }) =>({
    ...state,
    accessToken,
    refreshToken,
    user,
    loading: true,
    isAuthenticated: false
  })),
  on(authActions.submitLoginRequestFailure, (state, error) => ({
    ...state,
    loading: false,
    isAuthenticated: false,
    error: error.error.errorMessage
  })),
  on(authActions.submitLogoutRequest, (state) => ({
    ...state,
    loading: true,
    isAuthenticated: true
  })),
  on(authActions.submitLogoutRequestSuccess, (state) => ({
    ...state,
    accessToken: null,
    refreshToken: null,
    user: null,
    loading: false,
    isAuthenticated: false
  })),
  on(authActions.submitLogoutRequestFailure, (state, error) => ({
    ...state,
    loading: false,
    isAuthenticated: true,
    error: error.error.errorMessage
  })),
  on(authActions.submitPasswordResetRequest, (state) => ({
    ...state,
    loading: true,
  })),
  on(authActions.submitLogoutRequestSuccess, (state) => ({
    ...state,
    loading: false
  })),
  on(authActions.submitPasswordResetRequestFailure, (state, error) => ({
    ...state,
    loading: false,
    error: error.error.errorMessage
  })),
  on(authActions.submitForgotPasswordRequest, (state) => ({
    ...state,
    loading: true,
  })),
  on(authActions.submitForgotPasswordRequestSuccess, (state) => ({
    ...state,
    loading: false
  })),
  on(authActions.submitForgotPasswordRequestFailure, (state, error) => ({
    ...state,
    loading: false,
    error: error.error.errorMessage
  }))
);